<template>
  <div>
    <div class="spanning-wrap" v-if="loading">
      <a-spin class="spin-item" :spinning="loading" />
    </div>
    <Empty v-else-if="isEmpty"></Empty>
    <a-row class="row-item" :gutter="16">
      <a-col v-for="item in resultList" :key="item.id" :span="6">
        <div class="video-item" @click="playVideo(item)">
          <MediaWrap
            :height="150"
            :url="item.fileVo && item.fileVo.url"
          ></MediaWrap>
          <div class="content-describe-wrap">
            <div class="name">{{ item.name }}</div>
            <div class="content-describe-wrap-bottom">
              <div class="detail">
                {{ item.content }}
              </div>
            </div>
            <div class="content-describe-middle" v-if="homeShow">
              <span>{{ item.publishTime }}</span>
              <span>
                <a-icon type="eye" :style="{ color: '#364759' }" />
                {{ item.browseNum }}
              </span>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
    <VideoPlay
      ref="video"
      :videoUrl="url"
      @cancelPlay="cancelPlay"
      :loading="loadingVideo"
    ></VideoPlay>
  </div>
</template>

<script>
import VideoPlay from '@/components/videoplayer/videoplayer'
import { mapGetters } from 'vuex'
import { getVideoInfoDetail, viewsVideInfo } from '@/api/MTrainVideo.js'
import Empty from '@/components/common/Empty';

export default {
  props: {
    resultList: Array,
    loading: Boolean,
    isEmpty: Boolean,
    homeShow: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      url: '', // 播放视频的路径
      searchParams: {
        pageSize: 8,
        pageNum: 1,
      },
      loadingVideo: false, // 加载视频
    }
  },
  components: {
    VideoPlay,
    Empty
  },
  computed: {
    ...mapGetters('user', ['account']),
  },
  methods: {
    async playVideo(instance) {
      if (this.account === '游客' || this.account === '') {
        return this.$apiStatusHandler(20, '请登录观看视频资源')
      }
      try {
        this.loadingVideo = true
        const { code, data } = await getVideoInfoDetail(instance.id)
        if (code === 200) {
          await viewsVideInfo(instance.id)
          this.$refs.video.showModal()
          if (data.fileUploadVo) {
            this.url = data.fileUploadVo.url
          }
        }
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loadingVideo = false
      }
    },
    // 取消播放
    cancelPlay() {
      this.url = ''
      this.loadingVideo = false
    },
  },
}
</script>